/**
 * api接口统一管理
 */
import { get, post } from "./axios";

/**
 *
 * @param {string} params
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */

// 账号密码登录，返回token
export const login = (params) => post(`/open/auth/login/${ params.client }`, params);

// 获取图片验证码
export const getCode = (params) => get(`/open/code`, params);

// 校验图片验证码
export const getCheckCode = (params) => get(`/open/code/check/${params.uuid}/${params.code}`, params);

// 手机验证码登录：发送验证码
export const sendLoginCode = (params) => post(`/open/auth/sms-login-code-captcha/${params.phone}/${params.uuid}/${params.captcha}`, params);

// 手机验证码登录：登录认证
export const codeLogin = (params) => post(`/open/auth/login/${params.client}/${params.phone}/${params.code}`, params);



// WEBPACK FOOTER //
// ./src/api/login.js